import { DaoModel } from './daoModel';
import { FrontRoute } from './frontRoute';

export class FrontGroup extends DaoModel {
  constructor(guid, availableFrontRoutes, nameToFte) {
    super(guid);
    this.availableFrontRoutes = availableFrontRoutes;
    this.name = nameToFte;
  }

  static toInstance(props = {}) {
    const availableFrontRoutes = FrontRoute.toInstanceList(props.available_front_routes);
    return new FrontGroup(props.guid, availableFrontRoutes, props.name_to_fte);
  }

  serialize() {
    return {
      ...super.serialize(),
      available_front_routes: this.availableFrontRoutes,
      name_to_fte: this.name
    };
  }
}
